/* eslint-disable no-useless-catch */
import { API } from "../api";

const CLIENT_INVOICES_URL = "/client-invoices";

export const GET_CLIENT_INVOICES = "GET_CLIENT_INVOICES";

export const getClientInvoices = (filter = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.post(CLIENT_INVOICES_URL, filter);
      dispatch({
        type: GET_CLIENT_INVOICES,
        payload: res
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

const initialState = {
  columns: [],
  rows: [],
  totalRows: 0
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_CLIENT_INVOICES:
      return {
        ...state,
        columns: payload?.columns || [],
        rows: payload?.rows || [],
        totalRows: payload?.count || 0
      };
    default:
      return state;
  }
}
